import { useState } from 'react';

export type InputHandler = {
    value: unknown;
    changeHandler: (value: unknown) => void;
}

export function useInput(initialValue: unknown): InputHandler {
    const [value, setValue] = useState(initialValue);

    const handleInputChange = (newValue: unknown) => {
        setValue(newValue);
    };

    return {
        value,
        changeHandler: handleInputChange
    };
}
